import "bootstrap/dist/css/bootstrap.min.css";
import blogimge from "./image/blogimg.png";
import blogimg from "./image/blog-sec-img.jpeg";
import blogimg1 from "./image/blog-img1.png";
import blogimg2 from "./image/blog-img2.png";
import blogimg3 from "./image/blog-img3.png";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

function Blog() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    AOS.init({
      once: false,
      disable: "phone",
      duration: 1000,
      easing: "ease-out-cubic",
    });
  }, []);

  return (
    <>
      <link
        rel="stylesheet"
        href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
      ></link>
      <div className="body_section">
        <div className="blog-imge">
          <img src={blogimge} className="img-fluid" alt="..." />
        </div>

        <div class="container-fluid blog-img-section">
          <div class="container">
            <div class="row">
              <div
                data-aos="fade-up"
                className="col-lg-4 col-md-8 col-12 blog-img1"
              >
                <div className="blog-contain">
                  <img src={blogimg} alt="" style={{ width: "100%" }} />

                  <h2
                    style={{
                      color: " rgb(255 255 255)",
                      fontFamily: "sans-serif",
                      fontWeight: 700,
                    }}
                    data-aos="fade-up"
                  >
                    Our Best Services
                  </h2>

                  <p data-aos="fade-up">
                    <b data-aos="fade-up" style={{ color: "#eb4747" }}>
                      Custom Web Development:
                    </b>
                    Tailored web development services to meet the unique needs
                    of clients, including responsive design, robust
                    functionality, and user-friendly interfaces....
                  </p>

                  <p data-aos="fade-up">
                    <b data-aos="fade-up" style={{ color: "#eb4747" }}>
                      Software Development:{" "}
                    </b>
                    Full-cycle software development services, including
                    requirements gathering, architecture design, development,
                    testing, deployment, and maintenance for desktop, web, and
                    mobile platforms......
                  </p>

                  <p data-aos="fade-up">
                    <b data-aos="fade-up" style={{ color: "#eb4747" }}>
                      Mobile App Development:
                    </b>
                    Creation of native and cross-platform mobile applications
                    for iOS and Android platforms, ensuring seamless performance
                    and user experience.....
                  </p>

                  <p data-aos="fade-up">
                    <b data-aos="fade-up" style={{ color: "#eb4747" }}>
                      UI/UX Design:
                    </b>
                    Expert UI/UX design services to enhance user engagement and
                    satisfaction, focusing on intuitive interfaces, attractive
                    visuals, and smooth user experiences across all
                    devices......
                  </p>

                  <p data-aos="fade-up">
                    <b data-aos="fade-up" style={{ color: "#eb4747" }}>
                      E-commerce Solutions:
                    </b>
                    Development of secure and scalable e-commerce platforms,
                    incorporating features such as product management, payment
                    gateway integration, order processing, and customer
                    management.......
                  </p>

                  <p data-aos="fade-up">
                    <b data-aos="fade-up" style={{ color: "#eb4747" }}>
                      Content Management Systems (CMS):
                    </b>
                    Implementation of CMS solutions like WordPress, Drupal, or
                    custom-built CMS platforms to enable easy content creation,
                    publishing, and management for websites and
                    applications.....
                  </p>

                  <p data-aos="fade-up">
                    <b data-aos="fade-up" style={{ color: "#eb4747" }}>
                      Web Application Development:
                    </b>
                    Building dynamic and interactive web applications using
                    modern technologies like JavaScript frameworks (e.g., React,
                    Angular, Vue.js), backend technologies (e.g., Node.js,
                    Django, Flask), and databases (e.g., MongoDB, MySQL,
                    PostgreSQL)....
                  </p>

                  <p data-aos="fade-up">
                    <b data-aos="fade-up" style={{ color: "#eb4747" }}>
                      API Development and Integration:
                    </b>
                    Creation of custom APIs to facilitate seamless communication
                    between different software components or third-party
                    services, enabling data exchange and system integration....
                  </p>

                  <p data-aos="fade-up">
                    <b style={{ color: "#eb4747" }}>
                      Quality Assurance and Testing:
                    </b>
                    Comprehensive testing services, including functional
                    testing, performance testing, security testing, and
                    usability testing, to ensure the reliability, scalability,
                    and security of web and software applications.....
                  </p>

                  <p data-aos="fade-up">
                    <b style={{ color: "#eb4747" }}>Maintenance and Support:</b>
                    Ongoing maintenance, monitoring, and support services to
                    ensure the smooth operation and optimal performance of web
                    applications and software systems, including bug fixes,
                    updates, and security patches.....
                  </p>

                  <p data-aos="fade-up">
                    By offering these comprehensive services, our company can
                    cater to a wide range of client needs and deliver
                    high-quality solutions that drive business growth and
                    success..
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-8 col-12 ">
                <div className="blog-containn">
                  <img
                    data-aos="flip-up"
                    src={blogimg1}
                    alt=""
                    style={{ width: "100%" }}
                  />

                  <h2
                    style={{
                      color: " rgb(255 255 255)",
                      fontFamily: "sans-serif",
                      fontWeight: 700,
                    }}
                    data-aos="fade-up"
                  >
                    Pros and Cons of Mobile Native Apps vs Mobile Web Apps
                  </h2>

                  <p data-aos="fade-up">
                    <b>Custom Web Development:</b>Tailored web development
                    services to meet the unique needs of clients, including
                    responsive design, robust functionality, and user-friendly
                    interfaces....
                  </p>

                  <p data-aos="fade-up">
                    <b style={{ color: "#eb4747" }}>Software Development: </b>
                    Full-cycle software development services, including
                    requirements gathering, architecture design, development,
                    testing, deployment, and maintenance for desktop, web, and
                    mobile platforms......
                  </p>

                  <p data-aos="fade-up">
                    <b style={{ color: "#eb4747" }}>Mobile App Development:</b>
                    Creation of native and cross-platform mobile applications
                    for iOS and Android platforms, ensuring seamless performance
                    and user experience.....
                  </p>

                  <p data-aos="fade-up">
                    <b style={{ color: "#eb4747" }}>UI/UX Design:</b> Expert
                    UI/UX design services to enhance user engagement and
                    satisfaction, focusing on intuitive interfaces, attractive
                    visuals, and smooth user experiences across all
                    devices......
                  </p>

                  <p data-aos="fade-up">
                    <b style={{ color: "#eb4747" }}>E-commerce Solutions:</b>{" "}
                    Development of secure and scalable e-commerce platforms,
                    incorporating features such as product management, payment
                    gateway integration, order processing, and customer
                    management.......
                  </p>

                  <p data-aos="fade-up">
                    <b style={{ color: "#eb4747" }}>
                      Content Management Systems (CMS):
                    </b>
                    Implementation of CMS solutions like WordPress, Drupal, or
                    custom-built CMS platforms to enable easy content creation,
                    publishing, and management for websites and
                    applications.....
                  </p>

                  <p data-aos="fade-up">
                    <b style={{ color: "#eb4747" }}>
                      Web Application Development:
                    </b>
                    Building dynamic and interactive web applications using
                    modern technologies like JavaScript frameworks (e.g., React,
                    Angular, Vue.js), backend technologies (e.g., Node.js,
                    Django, Flask), and databases (e.g., MongoDB, MySQL,
                    PostgreSQL)....
                  </p>

                  <p data-aos="fade-up">
                    <b style={{ color: "#eb4747" }}>
                      API Development and Integration:
                    </b>
                    Creation of custom APIs to facilitate seamless communication
                    between different software components or third-party
                    services, enabling data exchange and system integration....
                  </p>

                  <p data-aos="fade-up">
                    <b style={{ color: "#eb4747" }}>
                      Quality Assurance and Testing:
                    </b>
                    Comprehensive testing services, including functional
                    testing, performance testing, security testing, and
                    usability testing, to ensure the reliability, scalability,
                    and security of web and software applications.....
                  </p>

                  <p data-aos="fade-up">
                    <b style={{ color: "#eb4747" }}>Maintenance and Support:</b>
                    Ongoing maintenance, monitoring, and support services to
                    ensure the smooth operation and optimal performance of web
                    applications and software systems, including bug fixes,
                    updates, and security patches.....
                  </p>

                  <p data-aos="fade-up">
                    By offering these comprehensive services, our company can
                    cater to a wide range of client needs and deliver
                    high-quality solutions that drive business growth and
                    success..
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-12">
                <div className="blog-search">
                  <h3 data-aos="fade-up">Search</h3>
                  <div className="d-flex">
                    <input data-aos="fade-up" type="text"></input>
                    <button data-aos="fade-up">
                      <i class="fa fa-search"></i>
                    </button>
                  </div>
                  <h3 data-aos="fade-up">Categories</h3>
                  <p data-aos="fade-up">IT(1)</p>
                  <p data-aos="fade-up">Tech Update(1)</p>
                  <div className="row">
                    <h3 data-aos="fade-up">Recent Posts</h3>
                    <div data-aos="fade-up" className="col-lg-4">
                      <img src={blogimg} alt="" style={{ width: "100%" }} />
                    </div>
                    <div className="col-lg-8">
                      <p data-aos="fade-up">
                        Why Small Business Need a Website
                      </p>
                    </div>

                    <div data-aos="fade-up" className="col-lg-4" id="post-img">
                      <img src={blogimg2} alt="" style={{ width: "100%" }} />
                    </div>
                    <div data-aos="fade-up" className="col-lg-8">
                      <p>Why Small Business Need a Website</p>
                    </div>
                  </div>

                  <h5 data-aos="fade-up">Tags</h5>
                  <ul data-aos="fade-up">
                    <li>Development</li>
                    <li>Email Marketing</li>
                    <li>Website</li>
                    <li>SMO</li>
                    <li>Mobile APP</li>
                    <li>IT</li>
                    <li>Marketing</li>
                    <li>Graphic Designing</li>
                    <li>Tech Update</li>
                    <li>SMM</li>
                    <li>Ads</li>
                    <li>ERP</li>
                    <li>SEO</li>
                  </ul>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-4 col-md-8 col-12">
                  <div className="blog-containn">
                    <img
                      data-aos="flip-up"
                      src={blogimg2}
                      alt=""
                      style={{ width: "100%" }}
                    />

                    <h2
                      style={{
                        color: " rgb(255 255 255)",
                        fontFamily: "sans-serif",
                        fontWeight: 700,
                      }}
                      data-aos="fade-up"
                    >
                      "Special Announcement for Freshers: What's New for You"
                    </h2>

                    <p data-aos="fade-up">
                      <b>Exclusive Orientation Program:</b>Dive into our
                      tailored orientation designed to help you transition
                      smoothly into campus life and discover essential
                      resources.
                    </p>

                    <p data-aos="fade-up">
                      <b style={{ color: "#eb4747" }}>
                        New Mentorship Opportunities:{" "}
                      </b>
                      Connect with senior students and industry professionals
                      for guidance and insights on academic and career success.
                    </p>

                    <p data-aos="fade-up">
                      <b style={{ color: "#eb4747" }}>
                        Innovative Learning Spaces:
                      </b>
                      Experience newly upgraded classrooms, collaborative zones,
                      and tech labs to enhance your learning environment.
                    </p>

                    <p data-aos="fade-up">
                      <b style={{ color: "#eb4747" }}>
                        Fresher-Only Clubs and Events:{" "}
                      </b>{" "}
                      Join exclusive clubs, attend workshops, and participate in
                      exciting social events designed just for you to build
                      friendships and networks.
                    </p>

                    <p data-aos="fade-up">
                      <b style={{ color: "#eb4747" }}>
                        Career Development Support :{" "}
                      </b>{" "}
                      Access special career counseling, skill-building sessions,
                      and internship opportunities aimed at setting you up for
                      future success.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-8 col-12">
                  <div className="blog-containn">
                    <img
                      data-aos="flip-up"
                      src={blogimg3}
                      alt=""
                      style={{ width: "100%" }}
                    />
                    <h2
                      style={{
                        color: " rgb(255 255 255)",
                        fontFamily: "sans-serif",
                        fontWeight: 700,
                      }}
                      data-aos="fade-up"
                    >
                      Designing with a pro mindset: strategies for success
                    </h2>
                    <ul>
                      <li data-aos="fade-up">
                        <i data-aos="fade-up" class="fa fa-calendar-o"></i>{" "}
                        2021-08-14
                      </li>
                    </ul>
                    <p>
                      <b style={{ color: "#eb4747" }} data-aos="fade-up">
                        Research and Understand the User:
                      </b>
                      Begin with deep user research to grasp their needs, pain
                      points, and preferences. Design with empathy, keeping the
                      end-user at the heart of every decision.
                    </p>

                    <p data-aos="fade-up">
                      <b style={{ color: "#eb4747" }}>
                        Focus on Functionality:{" "}
                      </b>
                      Prioritize usability and clarity. A professional design is
                      not just visually appealing but also intuitive and easy to
                      navigate.
                    </p>

                    <p data-aos="fade-up">
                      <b style={{ color: "#eb4747" }}>Iterative Prototyping:</b>
                      Develop quick prototypes and gather feedback early in the
                      process. Refine designs based on real-world use cases and
                      critiques...
                    </p>

                    <p data-aos="fade-up">
                      <b style={{ color: "#eb4747" }}>Attention to Detail:</b>{" "}
                      Pro-level designs demand perfection in details like
                      typography, spacing, and color schemes. Small adjustments
                      can make a big difference in the user experience.
                    </p>

                    <p data-aos="fade-up">
                      <b style={{ color: "#eb4747" }}>
                        Collaborate Effectively:{" "}
                      </b>
                      Work closely with cross-functional teams—developers,
                      marketers, and clients—to ensure design objectives align
                      with broader business goals.
                    </p>

                    <p data-aos="fade-up">
                      <b style={{ color: "#eb4747" }}>
                        Stay Updated on Trends:
                      </b>
                      Keep an eye on evolving design trends and emerging
                      technologies, but always ensure they complement the
                      design’s purpose, not overshadow it.
                    </p>

                    <p data-aos="fade-up">
                      <b style={{ color: "#eb4747" }}>
                        Time Management and Discipline:
                      </b>
                      Balance creativity with productivity by setting clear
                      deadlines and milestones to maintain a consistent
                      workflow.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Blog;
